export const pagesWithAnimationList = [
    "/vinovest-100-index",
    "/why-wine",
    "/advisors",
    "/wine-futures",
    "/whiskey-investment",
    "/reserve-cask",
    "/home",
    "/about-us",
    "/how-it-works",
    "/sustainability",
    "/",
];
